import { useEffect, useState } from "react";

interface urlParam {
    page?: string;
    parametro?: string;
    atributo?: string;
};

interface Props {
    urlElement: urlParam;
}

export const BreadcrumbNav = ({ urlElement }: Props) => {

    const [url, setUrl] = useState<Partial<urlParam>>({});

    useEffect(() => {
        setUrl(urlElement);
    }, [urlElement]);

    const renderSwitchParameter = (url: string) => {
        switch (url) {
            case 'mesagges':
                return "Mensajes";
            case 'personal-info':
                return "Información Personal";
            case 'credit-lines':
                return "Lineas de Credito";
            case 'requests':
                return "Solicitudes";
            case 'credits-loans':
                return "Creditos Disponibles";
            case 'products':
                return "Mis Productos";
            case 'init-turn':
                return "Solicitar agendamiento";
            case 'services':
                return "Servicios disponibles";
            case 'history-turn':
                return "historial de agendamientos";
            case 'active-turn':
                return "Agendamientos activos";
            case 'personal-account-info':
                return "Información Personal";
            case 'mi-contract':
                return "Lista de Contratos";
            case "mi-contract-detail":
                return "Detalles del Contrato";
            default:
                return "No encontrado";
        }
    }

    const renderSwitchPage = (url: string) => {
        switch (url) {
            case 'home':
                return ("Principal");

            default:
                return "No encontrado";
        }
    }

    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item disabled" aria-disabled="true">
                    <a href="#/" onClick={(e) => e.preventDefault()} style={{ pointerEvents: 'none', color: 'gray' }}>
                        Portal
                    </a>
                </li>
                <li className="breadcrumb-item disabled" aria-disabled="true">
                    <a href="#/" onClick={(e) => e.preventDefault()} style={{ pointerEvents: 'none', color: 'gray' }}>
                        {renderSwitchPage(url.page)}
                    </a>
                </li>
                {url.page && (
                    <li className="breadcrumb-item active" aria-current="page">
                        {renderSwitchParameter(url.parametro)}
                    </li>
                )}
            </ol>
        </nav>

    );
};